import { GetDayKeyFromHourKey } from "../QuickJournalKeys";

export function BuildQuickJournalDayCountsFromHourlyCounts(
    hourlyCounts: Record<string, number>
): Record<string, number> {
    const counts: Record<string, number> = {};

    Object.entries(hourlyCounts).forEach(([cellKey, count]) => {
        const dayKey = GetDayKeyFromHourKey(cellKey);

        if (!dayKey) {
            return;
        }

        counts[dayKey] = (counts[dayKey] ?? 0) + count;
    });

    return Object.fromEntries(
        Object.entries(counts).sort(([left], [right]) =>
            left.localeCompare(right)
        )
    );
}
